import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import CONSTANTS from 'src/@utility/constants';
import { StorageService } from './storage.service';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  appKeyValues: any;
  private appKeyValueUpdate = new ReplaySubject<any>(1);
  private appKeyValueUpdate$ = this.appKeyValueUpdate.asObservable();

  constructor(
    private restApi: RequestService,
    private storageService: StorageService
  ) {
    this.appKeyValues = this.storageService.getItem(
      CONSTANTS.appKeyValuesStoreKey
    );
  }

  load(option) {
    if (this.appKeyValues && !(option && option.dropCache)) {
      this.appKeyValues = this.storageService.getItem(
        CONSTANTS.appKeyValuesStoreKey
      );
      this.appKeyValueUpdate.next(this.appKeyValues);
      return this.appKeyValueUpdate$;
    }

    this.restApi
      .get('/api/v5/app-key-value-stores')
      .pipe(
        switchMap((kvResp) => {
          return this.restApi
            .get('/api/v5/app-key-blob-stores')
            .pipe(map((kvbResp) => [...kvResp.body, ...kvbResp.body]));
        }),
        map((response: any) => {
          return response.reduce((all, keyValue) => {
            all[keyValue.key] = keyValue.value;
            return all;
          }, {});
        })
      )
      .subscribe((response) => {
        this.storageService.setItem(CONSTANTS.appKeyValuesStoreKey, response);
        this.appKeyValueUpdate.next(response);
      });

    return this.appKeyValueUpdate$;
  }
}
